import request from "./request";
import apis from "./apis";

const {
  accountInfo,
  userAccount,
  userAccountDetail,
  userAccountById,
  allTeacherAccount,
  changePassword,
  createUser,
  userAgentInfo,
  userFileInfo,
  uploadUserFile,
  deleteUserFile,
  downloadUserFile,
  exportUserFile,
  importUserFile,
  resetUserPassword,
  facultyAccount,
  importFacultyFile,
} = apis.user;

const user = {
  getAccountInfo: () => {
    return request.get(accountInfo);
  },
  getUserAccount: () => {
    return request.get(userAccount);
  },
  deleteUserAccount: (data: Object) => {
    return request.delete(userAccount, data);
  },
  updateUserAccount: (data: Object) => {
    return request.formJsonPut(userAccount, data);
  },
  deleteUserAccountDetail: (id: string) => {
    return request.idDelete(userAccountDetail, id);
  },
  getUserAccountById: (data: Object) => {
    return request.get(userAccountById, data);
  },
  getAllTeacherAccount: () => {
    return request.get(allTeacherAccount);
  },
  changePassword: (data: Object) => {
    return request.put(changePassword, data);
  },
  createUser: (data: Object) => {
    return request.formJsonPost(createUser, data);
  },
  getUserAgentInfo: (data: Object) => {
    return request.get(userAgentInfo, data);
  },
  getUserFileList: (data: Object) => {
    return request.get(userFileInfo, data);
  },
  uploadUserFile: (data: Object) => {
    return request.formJsonStringPost(uploadUserFile, data);
  },
  deleteUserFile: (id: string) => {
    return request.idDelete(deleteUserFile, id);
  },
  downloadUserFile: (id: string) => {
    return request.idGetBlob(downloadUserFile, id);
  },
  exportUserFile: (data: Object) => {
    return request.get(exportUserFile, data);
  },
  importUserFile: (data: Object) => {
    return request.formJsonPost(importUserFile, data);
  },
  resetUserPassword: (data: Object) => {
    return request.get(resetUserPassword, data);
  },
  updateFacultyAccount: (data: Object) => {
    return request.formJsonPut(facultyAccount, data);
  },
  importFacultyFile: (data: Object) => {
    return request.formJsonPost(importFacultyFile, data);
  },
};

export default user;